const useFeaturedImage = props => props?.featuredImage?.node?.localFile?.childImageSharp?.fluid?.src

export default useFeaturedImage
